<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="采访标题">
            <a-input v-model="searchForm.title" allowClear placeholder="请输入采访标题" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="被采访人">
            <a-input v-model="searchForm.name" allowClear placeholder="请输入被采访人" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="采访人">
            <a-input v-model="searchForm.nickname" allowClear placeholder="请输入采访人" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.status" allowClear show-search option-filter-prop="children" placeholder="请选择状态" style="width: 100%">
              <a-select-option v-for="item in INTERVIEW_STATUS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <v-range-picker v-model="times" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="$router.push('/interview/edit')">添加采访</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" ghost icon="delete" @click="handleClear">清空</a-button>
        <!-- <a-button icon="sync">刷新表格</a-button> -->
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :scroll="{x: true}" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="user_id" slot-scope="text, record">
        {{ record.user_name | fillBlank }} ({{ text }})
      </template>
      <template slot="status" slot-scope="text, record">
        <span v-if="text === 1" style="color: #FE9501;">{{ showName('INTERVIEW_STATUS', text) }}</span>
        <span v-else-if="text === 2">
          <span style="color: #18BE6B;">{{ showName('INTERVIEW_STATUS', text) }}  <span v-if="record.is_show === 0" style="color: red;">（已下线）</span></span>
        </span>
        <span v-else style="color: red;">{{ showName('INTERVIEW_STATUS', text) }}</span>
      </template>
      <template slot="operator" slot-scope="text, record">
        <div class="flex-sb">
          <a-dropdown>
            <a-button size="small" type="link">审核</a-button>
            <a-menu slot="overlay" @click="handleTableCommand($event, record)">
              <a-menu-item :key="2">通过</a-menu-item>
              <a-menu-item :key="3">拒绝</a-menu-item>
            </a-menu>
          </a-dropdown>
          <!-- <a-button size="small" @click="handleTableCommand('check', record)">审核</a-button> -->
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <!-- <a-button size="small" type="link" @click="handleTableCommand('delete',record)">删除</a-button> -->
          <template v-if="record.status==2">
            <a-button size="small" v-if="record.is_show === 1" type="link" @click="handleTableChangeIsShow(record)">下线</a-button>
            <!-- 文章下线后允许进行上线操作，点击【上线】后，在前端页面展示，文章期数不变 -->
            <a-button size="small" v-if="record.is_show === 0" type="link" @click="handleTableChangeIsShow(record)">上线</a-button>
          </template>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
import { ref, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommand } from './business/tableLogic'
import { searchForm, columns } from './business/InterviewList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      times: [],
      platformList: [],
      searchForm: { ...searchForm }
    })

    onMounted(async () => {
      state.searchForm = _this.SEARCH_FORM
      state.times = _this.SEARCH_FORMDAY
      await methods.getList()
      methods.getPlatform()
    })

    onUnmounted(async () => {
      if (!_this.$route.params.id) {
        _this.SET_SEARCH[0]({})
        _this.SET_SEARCHDAY[0]([])
      }
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        _this.SET_SEARCHDAY[0](state.times)
        _this.SET_SEARCH[0](state.searchForm)
        this.getList()
      },

      async getList() {
        _this.loading = true
        const [start_date, end_date] = state.times
        _this.searchForm.start_date = start_date
        _this.searchForm.end_date = end_date
        const res = await api.listInterview({
          ...state.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        // const { interview, pagination } = res?.data
        const interview = res?.data?.interview || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = interview
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineList()
        state.platformList = res.data
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        const type_id = typeof type === 'object' ? 'check' : type
        strategyCommand[type_id].call(_this, ...arg, type.key)
      },

      handleTableChangeIsShow(record) {
        const params = { id: record.id, is_show: record.is_show === 1 ? 0 : 1 }
        if (record.is_show === 1) {
          const _this = this
          this.$confirm({
            title: '下线',
            content: '您是否确认下线该文章？文章下线后将不再在前台页面显示。',
            onOk() {
              _this.changeIsShow(params)
            }
          })
        } else {
          this.changeIsShow(params)
        }
      },

      changeIsShow(params) {
        api.updateInterviewIsShow(params).then(res => {
          this.getList()
        })
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
